module.exports = __webpack_public_path__ + "media/en_au_s2_Ethan.1b777924.oga";